export const SITE_URL = "https://bhaaratwealthgroup.com";

export const SOCIALS = {
  instagram: "https://www.instagram.com/bhaaratwealthgroup/",
  facebook: "https://www.facebook.com/bhaaratwealthgroup/",
  linkedin: "https://www.linkedin.com/company/bhaarat-wealth-group/",
};

export const CONTACT = {
  phone: "+91-9971169695",
  email: "info@bhaaratwealthgroup.com",
  careersEmail: "careers@bhaaratwealthgroup.com",
};

export const orgSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Bhaarat Wealth Group",
  alternateName: "BWG",
  url: SITE_URL,
  logo: `${SITE_URL}/assets/bwg-logo.png`,
  description:
    "Bhaarat Wealth Group is a land investment intelligence firm that sources, structures and delivers high-conviction land opportunities across India's strategic growth corridors.",
  parentOrganization: {
    "@type": "Organization",
    name: "Philom Tech Pvt. Ltd.",
    address: {
      "@type": "PostalAddress",
      addressLocality: "New Delhi",
      addressCountry: "IN",
    },
  },
  address: {
    "@type": "PostalAddress",
    streetAddress: "Connaught Place",
    addressLocality: "New Delhi",
    addressRegion: "Delhi",
    addressCountry: "IN",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: CONTACT.phone,
    email: CONTACT.email,
    contactType: "customer service",
    areaServed: "IN",
    availableLanguage: ["English", "Hindi"],
  },
  sameAs: [SOCIALS.instagram, SOCIALS.facebook, SOCIALS.linkedin],
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});
